module.exports = __webpack_public_path__ + "img/right.afe5ef12.png";